import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tabs from '../tabs/Tabs';
import Notifications from '../notifications/Notifications';
import { ErrorBoundary } from "react-error-boundary";
const App = () => {
    return (_jsxs("div", Object.assign({ className: "wrap" }, { children: [_jsx("h1", Object.assign({ style: { fontSize: '30px' } }, { children: _jsx("span", Object.assign({ style: { color: '#674399' } }, { children: "Delete All Products" })) })), _jsxs(ErrorBoundary, Object.assign({ fallback: _jsx("div", { children: "Something went wrong" }) }, { children: [_jsx(Tabs, {}), _jsx(Notifications, {})] }))] })));
};
export default App;
